import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { initialVideoFolderState } from '..';
import { updateProjectMetaAsync } from '../../actions';
import { findAndUpdateProject } from '../../helpers';
import { VideoFolderActions } from '../../types';

const updateProjectMetaReducer: Reducer<typeof initialVideoFolderState, VideoFolderActions> = (
  state = initialVideoFolderState,
  action
) => {
  switch (action.type) {
    case getType(updateProjectMetaAsync.request): {
      const params = action.payload;
      return {
        ...state,
        updateProjectMeta: {
          ...state.updateProjectMeta,
          params,
          isError: false,
          isPending: true
        }
      };
    }
    case getType(updateProjectMetaAsync.success): {
      const { params } = state.updateProjectMeta;

      return {
        ...state,
        data: findAndUpdateProject(
          state.data!,
          params!.projectId
        )(v => ({
          ...v,
          name: params!.meta.name
        })),

        updateProjectMeta: {
          ...state.updateProjectMeta,
          isPending: false
        }
      };
    }
    case getType(updateProjectMetaAsync.failure): {
      const error = action.payload;

      return {
        ...state,
        updateProjectMeta: {
          ...state.updateProjectMeta,
          error,
          isError: true,
          isPending: false
        }
      };
    }
    default:
      return state;
  }
};

export default updateProjectMetaReducer;
